import { reducerWithInitialState } from "typescript-fsa-reducers";
import {TopMenuStateInitialState, deepCopyTopMenuState } from "../typing/top_menu_state";
import {setTopMenuDropdownIsOpen, setTopMenuEntry, setFullscreen} from "../actions/top_menu_actions";

export default  reducerWithInitialState(TopMenuStateInitialState)
    .case(setTopMenuDropdownIsOpen, (state, payload) => { 
        const deepCopy = deepCopyTopMenuState(state);
        deepCopy.isDropdownOpen = payload.isopen;
        return deepCopy; 
    })
    .case(setTopMenuEntry, (state, payload) => {
        const deepCopy = deepCopyTopMenuState(state);
        deepCopy.selectedMenuPoint = payload.nextentry;
        return deepCopy;
    })
    .case(setFullscreen, (state, payload) => {
        const deepCopy = deepCopyTopMenuState(state);
        deepCopy.isFullscreenEnabled = payload.fullscreenenable;
        return deepCopy;
    });